<button
  type="button"

  (click)="open()"

  class="
    px-2 py-1
    rounded
    bg-blue-50
    text-blue-700
    text-xs
    hover:bg-blue-100
  ">

  Tax

  <span
    *ngIf="taxAmount > 0">

    ({{ taxAmount }})

  </span>

</button>